import React, { useEffect, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import rp from 'request-promise-native'
import * as actions from '../../redux/actions'

import Sheet from './Sheet'
import Menu from './Menu'
import MissingColor from './MissingColor'
import useLanguage from '../../hooks/useLanguage'

const Croma = props => {
  const history = useHistory()

  const language = useLanguage()

  const renderProColoring = useMemo(() => props.user.universe === 'feminine', [props.user.universe])

  useEffect(() => {
    rp({
      uri: `https://public-api.wordpress.com/rest/v1.1/sites/trendsmosty.wordpress.com/posts/?after=${props.dateOfLastReading}`,
      method: 'GET',
      json: true
    })
      .then(data => {
        props.setNumberOfNewPosts(data.found)
      })
      .catch(err => console.error(err))
  }, [])

  return props.user.personalColoring || (props.user.userPersonalColor && props.user.userPersonalColor.length) ? (
    !renderProColoring ? (
      <Sheet history={history} />
    ) : (
      <Menu
        language={language}
        history={history}
        user={props.user}
      />
    )
  ) : (
    <MissingColor language={language} history={props.history} token={props.token} />
  )
}

const mapStateToProps = state => ({
  ...state.userReducer,
  dateOfLastReading: state.notificationReducer.trends.dateOfLastReading
})

export default connect(
  mapStateToProps,
  actions
)(Croma)



// WEBPACK FOOTER //
// ./src/containers/Cromatica/Cromatica.js